// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import type { Action, PayloadAction } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { defaultBaseUrl } from "../constants/urls";

function isHydrateAction(action: Action): action is PayloadAction<any> {
  return action.type === "__NEXT_REDUX_WRAPPER_HYDRATE__";
}

let baseUrl = defaultBaseUrl;
try {
  // @ts-ignore
  baseUrl = import.meta.env.VITE_API_ROOT || defaultBaseUrl;
} catch (e) {}

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySlinkyApi = createApi({
  reducerPath: "slinkyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl + "/",
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as any).auth.user?.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath];
    }
  },
  endpoints: () => ({}),
});
